import { motion } from "framer-motion";
//import { MdKeyboardArrowUp } from "react-icons/md"; // Material Design
import MdKeyboardArrowUp from "./MdKeyboardArrowUp"; 
import { useTranslation } from "react-i18next";
/* import { FaChevronUp } from "react-icons/fa"; // Font Awesome
import { BsChevronUp } from "react-icons/bs"; // Bootstrap Icons
import { IoChevronUp } from "react-icons/io5"; // Ionicons v5 */

export default function ScrollToTopButton() {    
    const { t } = useTranslation();

    const handleScrollToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	};

    return (
        <section
			className={`
                flex flex-col justify-end items-center 
                w-[40px] xl:w-[70px] 2xl:w-[5vw] aspect-square hover:scale-110 active:scale-90 active:duration-150
                cursor-pointer transition-all duration-500
            `}			
		>
			<motion.button 
				className="font-size-from-base-to-2xl min-w-12 aspect-square flex items-end justify-center"
				aria-label={t("navBarItems.floatingActionShortcuts.scrollToTop.title")}
				title={t("navBarItems.floatingActionShortcuts.scrollToTop.title")}
				onClick={handleScrollToTop}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{
                    type: "spring",
                    stiffness: 500,
                    damping: 20,
                    bounce: 0.6,
                    delay: 3,
                }}
                whileTap={{ scale: 0.9 }}
                type="button"
			>
				<MdKeyboardArrowUp />
			</motion.button>
		</section>
    )
}